import {InterfaceViewModelTemplate} from "./InterfaceViewModelTemplate";

/**
 * ビューモデルのテンプレートクラス
 */
export abstract class AbstractViewModelTemplate implements InterfaceViewModelTemplate{
    public abstract mediate(): Promise<void>;
}